import { Theme } from "@nivo/core";

/**
 * Gets the chart theme for the analytic charts.
 * @function
 * @name getChartTheme
 * @kind function
 * @returns {Theme} The chart theme.
 * @exports
 */
export function getChartTheme(): Theme {
  return {
    axis: {
      // sets the color of the text graphic ticks
      ticks: {
        text: {
          fill: "#9B9B9B",
          fontSize: 12,
        },
      },
    },
  };
}
